import { ReceiptAutoPrint } from "../types";
import { BaseRequest } from "./base-request";

export abstract class PosApiRequest extends BaseRequest {
  Merchant: string = "00";

  // Indicates where the request is to be sent to. Defaults to "00" (EFTPOS).
  Application: string = "00";

  //Specify how the receipt should be printed.
  ReceiptAutoPrint: ReceiptAutoPrint = ReceiptAutoPrint.POS;

  CutReceipt?: boolean | undefined;

  PosName: string;

  // POS version
  PosVersion: string;

  // POS version
  PosId: string;

  PurchaseAnalysisData?: { [key: string]: string };

  //wrap the request data in a "Request" json key
  serialize(): Record<string, any> {
    const serialized = super.serialize();
    return {
      request: serialized,
    };
  }
}
